module.exports = __webpack_public_path__ + "img/Back_Up_2.3112a5dd.svg";